<app-collapsible [trigger]="item === undefined">
  <form>
    <div class="form-group" style="padding-top: 15px">
      <label for="searchBy" class="mr-3">Search by</label>
      <mat-radio-group name="registrantSearchBy" id="registrantSearchBy" (ngModelChange)="setFocus()"
        [(ngModel)]="searchParams.searchBy">
        <mat-radio-button [value]="RegisterSearchBy.Number" name="number" type="radio">Registration number
        </mat-radio-button>
        <mat-radio-button [value]="RegisterSearchBy.Name" name="name" type="radio">Name</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="row">
      @if (searchByNumber) {
        <div class="col-md-6">
          <div class="form-group"
            [class.invalid]="searchByNumber && (searched || touched || regNumber.touched ) && regNumber.errors?.required">
            <input type="search" #focus class="form-control" placeholder="Enter number..." name="regNumber" id="regNumber"
              required (ngModelChange)="clearNoResults()" #regNumber="ngModel" [(ngModel)]="searchParams.regNumber">
              <app-collapsible
                [trigger]="searchByNumber && (searched || touched || regNumber.touched ) && regNumber.errors?.required">
                <p class="form-error">
                  Please enter a registration number
                </p>
              </app-collapsible>
            </div>
          </div>
        }

        @if (searchByName) {
          <div class="col-md-3">
            <div class="form-group"
              [class.invalid]="searchByName && (searched || touched || lastName.touched ) && lastName.errors?.required">
              <input type="text" #focus class="form-control" placeholder="Last name..." id="lastName"
                [(ngModel)]="searchParams.lastName" required (ngModelChange)="clearNoResults()" #lastName="ngModel"
                name="lastName">
                <app-collapsible
                  [trigger]="searchByName && (searched || touched || lastName.touched ) && lastName.errors?.required">
                  <p class="form-error">
                    You must provide a last name
                  </p>
                </app-collapsible>
              </div>
            </div>
          }

          @if (searchByName) {
            <div class="col-md-3">
              <div class="form-group">
                <input type="text" class="form-control" (ngModelChange)="clearNoResults()" placeholder="First name..."
                  id="firstName" name="firstName" [(ngModel)]="searchParams.firstName">
                </div>
              </div>
            }

            <div class="col-md-4">
              <button class="btn btn-default btn-lg" type="submit" (click)="search()">Search</button>
            </div>
          </div>

        </form>

        <app-collapsible [trigger]="searching">
          <div style="display:flex;align-items:center;padding-bottom:10px;">
            <app-spinner [tiny]="true"></app-spinner>
            <div style="padding-left:10px">Searching for {{title}}s...</div>
          </div>
        </app-collapsible>

        <app-collapsible [trigger]="!searching && results !== undefined && results.length > 0">
          <div style="margin-top: 20px">
            <label id="resultsLabel" [class.error]="touched && !item">Select a {{title}}</label>
            <div class="results" #resultsList>
              <table class="table">
                <tr>
                  <th>Name</th>
                  <th>Number</th>
                  <th>Town</th>
                  <!-- <th>Eligible</th> -->
                </tr>
                @for (item of results; track item) {
                  <tr (click)="setSelected(item)" class="hover link"
                    style="font-size:0.8em">
                    <td>{{ item.forenames + ' ' + item.surname }}</td>
                    <td>{{ item.registrationNumber }}</td>
                    <td>{{ item.town }}</td>
                    <!-- <td>{{ item.eligibleAsTutor | friendlyBoolean }}</td> -->
                  </tr>
                }
              </table>
            </div>

            @if (showLoadMore) {
              <div class="text-center load-more">
                <button class="btn btn-default btn-lg btn-block " (click)="loadMore()" [disabled]="loadingMore">
                  @if (!loadingMore) {
                    <span>More results...</span>
                  }
                  @if (loadingMore) {
                    <span>Loading....</span>
                  }
                </button>
                @if (loadingMore) {
                  <div>
                    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
                  </div>
                }
              </div>
            }
          </div>
        </app-collapsible>

        @if (noResultsVisible) {
          <div>
            @if (searchParams.searchBy === RegisterSearchBy.Number) {
              <p class="intro-text">
                Couldn't find any {{title}}s with registration number '{{searchParams.regNumber}}'.
              </p>
            }
            @if (searchParams.searchBy === RegisterSearchBy.Name) {
              <p class="intro-text">
                Couldn't find any {{title}}s called '{{ (searchParams.firstName ? searchParams.firstName + ' ' : '') +
                searchParams.lastName
                }}'.
              </p>
            }
          </div>
        }

      </app-collapsible>

      <app-collapsible [trigger]="item !== undefined">
        <div class="row">
          <div class="col-md-6 limit-width">
            <div class="form-group">
              <div class="form-control" readonly>
                {{render(item)}}
              </div>
            </div>
          </div>
          <div class="col-md-4">
            @if (!readonly) {
              <button type="button" (click)="cancelSelection()" class="btn btn-default btn-lg">Change</button>
            }
          </div>
        </div>
      </app-collapsible>